import {
  Component,
  ElementRef,
  HostListener,
  inject,
  signal,
} from '@angular/core';
import { Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FeatureLockComponent } from '@ams/ui-kit';
import { NotificationService } from '../../../services/notification.service';
import { IconService } from '../../../services/icon.service';
import { FeatureFlagService } from '../../../services/feature-flag.service';
import { TenantTimeZoneService } from '../../../services/tenant-timezone.service';

@Component({
  selector: 'app-notification-bell',
  standalone: true,
  imports: [FontAwesomeModule, FeatureLockComponent],
  templateUrl: './notification-bell.component.html',
  styleUrl: './notification-bell.component.scss',
})
export class NotificationBellComponent {
  readonly notifService = inject(NotificationService);
  readonly iconService = inject(IconService);
  readonly features = inject(FeatureFlagService);
  private readonly router = inject(Router);
  private readonly elementRef = inject(ElementRef);
  private readonly tenantTimeZone = inject(TenantTimeZoneService);

  readonly isOpen = signal(false);

  toggle(): void {
    const opening = !this.isOpen();
    this.isOpen.set(opening);
    if (opening) {
      this.notifService.loadBellFeed();
    }
  }

  close(): void {
    this.isOpen.set(false);
  }

  dismiss(notificationId: string): void {
    this.notifService.dismiss(notificationId);
  }

  dismissAll(): void {
    this.notifService.dismissAll();
  }

  seeAll(): void {
    this.close();
    this.router.navigate(['/notifications']);
  }

  formatTimestamp(createdAt: string): string {
    const date = new Date(createdAt);
    const diffMs = Date.now() - date.getTime();
    const diffMin = Math.floor(diffMs / 60_000);
    const diffHr = Math.floor(diffMin / 60);
    const diffDays = Math.floor(diffHr / 24);

    if (diffMin < 1) return 'just now';
    if (diffMin < 60) return `${diffMin}m ago`;
    if (diffHr < 24) return `${diffHr}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return this.tenantTimeZone.formatDate(createdAt, 'short');
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target as Node)) {
      this.isOpen.set(false);
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.isOpen.set(false);
  }
}
